// `/app/splits/authorizations` (WEB-123, SPLIT-10, `19` §4.1): aba "Autorizações" da tela de Splits: a lista de quem pode receber parte das vendas do próprio seller. A
// rota-pai desenha o cabeçalho e as abas e põe este `<Outlet/>` no painel.
//
// Autorização não tem `mode`: as queries não levam o modo na key e trocar Produção/Teste não
// muda nada aqui (a tela diz isso).

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import {
  authorizationsQueryOptions,
  createSplitAuthorization,
  revokeSplitAuthorization,
  splitAuthorizationsKeys,
} from '../api/queries/splits.ts';
import { ReceiptText } from '../components/icons/index.tsx';
import { AuthorizationsPanel } from '../features/splits/authorizations-panel.tsx';
import { ActionLink } from '../features/splits/links.tsx';

function Authorizations() {
  const queryClient = useQueryClient();
  const list = useQuery(authorizationsQueryOptions());

  const invalidate = () => queryClient.invalidateQueries({ queryKey: splitAuthorizationsKeys.all });

  const create = useMutation({
    mutationFn: createSplitAuthorization,
    onSuccess: invalidate,
  });
  const revoke = useMutation({
    mutationFn: revokeSplitAuthorization,
    onSuccess: invalidate,
  });

  return (
    <AuthorizationsPanel
      authorizations={{
        data: list.data,
        isLoading: list.isPending,
        error: list.error,
        onRetry: () => {
          void list.refetch();
        },
      }}
      onAuthorize={async (email) => {
        await create.mutateAsync(email);
      }}
      onRevoke={async (id) => {
        await revoke.mutateAsync(id);
      }}
      newChargeLink={<ActionLink to="/app/transactions" label="Nova cobrança" icon={ReceiptText} />}
    />
  );
}

export const Route = createFileRoute('/app/splits/authorizations')({ component: Authorizations });
